import ProfileMlmSetting from 'components/Profile/components/ProfileMlmSetting/ProfileMlmSetting';

const ProfileMlmSettingPage = () => {
	return <ProfileMlmSetting />;
};

export default ProfileMlmSettingPage;
